import React from 'react'
import { Box, Flex, SearchInput, Text } from '@workwhile/ui'
import { useJurisdictionsContextValue } from '../context/JurisdictionsProvider'
import { WageJurisdictionLevel } from 'pages/Wage/types'

const LEVEL_OPTIONS: { value: WageJurisdictionLevel | ''; label: string }[] = [
  { value: '', label: 'All levels' },
  { value: 'federal', label: 'Federal' },
  { value: 'state', label: 'State' },
  { value: 'county', label: 'County' },
  { value: 'place', label: 'Place' },
]

export const JurisdictionsFilters = () => {
  const {
    state: { filters },
    actions: { setFilters },
  } = useJurisdictionsContextValue()

  return (
    <Flex gap={3} mb={3} flexWrap="wrap" alignItems="flex-end">
      <Box>
        <Text fontSize={1} color="lightText" mb={1}>
          Level
        </Text>
        <select
          value={filters.level ?? ''}
          onChange={(e) =>
            setFilters((prev) => ({
              ...prev,
              level: (e.target.value as WageJurisdictionLevel) || null,
            }))
          }
          style={{
            padding: '8px 10px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            fontSize: '13px',
            cursor: 'pointer',
          }}
        >
          {LEVEL_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </Box>
      <Box>
        <Text fontSize={1} color="lightText" mb={1}>
          State code
        </Text>
        <SearchInput
          keyword={filters.stateCode ?? ''}
          setKeyword={(val) =>
            setFilters((prev) => ({
              ...prev,
              stateCode: val.toUpperCase().slice(0, 2) || null,
            }))
          }
          placeholder="e.g. CA"
          clearable={false}
          style={{ width: 100 }}
        />
      </Box>
    </Flex>
  )
}
